import React, { useState } from 'react';
import strings from 'localization/strings';
import { makeStyles } from 'styles/util';
import { useAppContext } from 'context/AppContext';
import contactUsCategories from 'enums/contactUsCategories';
import iconEmail from 'assets/icons/email.svg';
import iconPhone from 'assets/icons/phone.svg';
import routes from 'routes';

import Typography from '@material-ui/core/Typography';
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Box from '@material-ui/core/Box';
import Button from '@material-ui/core/Button';
import MarginBox from 'common/MarginBox';
import { Link } from 'react-router-dom';

const useStyles = makeStyles(({ colors, theme }) => ({
    categorySelector: {
        padding: theme.spacing(2, 4),
        borderRadius: '4px',
        border: `2px solid ${colors.primaryColor}`,
        display: 'flex',
        flexDirection: 'column',
        gap: theme.spacing(3),
        [theme.breakpoints.down('sm')]: {
            gap: theme.spacing(4)
        }
    },
    categoryExamples: {
        marginLeft: theme.spacing(4),
        color: colors.darkGrey
    },
    contactBox: {
        color: colors.white,
        backgroundColor: colors.primaryColor,
        padding: theme.spacing(4),
        '& a': {
            color: colors.white,
            display: 'inline-block',
            marginRight: theme.spacing(4)
        },
        borderRadius: '4px'
    },
    imageSpan: {
        marginRight: '14px',
        verticalAlign: 'middle',
        '& img': {
            verticalAlign: 'middle',
            marginBottom: '4px'
        }
    }
}));

const ContactUsSection = () => {
    const classes = useStyles();
    const { appContext } = useAppContext();
    const [category, setCategory] = useState(null);

    const contactUsCategoriesToShow = Object.values(contactUsCategories);
    if(!appContext.useEmergencySupport) {
        contactUsCategoriesToShow.splice(contactUsCategoriesToShow.findIndex(o => o.key === contactUsCategories.emergency.key), 1);
    }

    return (
        <Box>
            <MarginBox bottom={2}>
                <Typography variant="body1">{strings.contactStorageBody}</Typography>
            </MarginBox>

            <MarginBox bottom={4}>
                <RadioGroup value={category} onChange={e => setCategory(e.target.value)} className={classes.categorySelector}>
                    {
                        contactUsCategoriesToShow.map(o => (
                            <Box key={o.key}>
                                <FormControlLabel value={o.key} control={<Radio />} label={o.title} />
                                {
                                    o.examples &&
                                    (
                                        <Typography variant="body2" className={classes.categoryExamples}>
                                            {o.examples}
                                        </Typography>
                                    )
                                }
                            </Box>
                        ))
                    }
                </RadioGroup>
            </MarginBox>

            {
                category &&
                (
                    <MarginBox bottom={2}>
                        <Typography variant="body1">
                            {contactUsCategories[category].description}
                        </Typography>
                    </MarginBox>
                )

            }

            {
                category === contactUsCategories.booking.key &&
                (
                    <Button
                        variant="contained"
                        color="primary"
                        component={Link}
                        to={routes.account.tenantBookings}
                    >
                        {strings.goToMyBookings}
                    </Button>
                )
            }

            {
                category === contactUsCategories.emergency.key &&
                (
                    <Box className={classes.contactBox}>
                        <a href={`tel:${appContext.company.canonicalTelephone}`}><Typography variant="body1"><span className={classes.imageSpan}><img src={iconPhone} alt={strings.iconPhoneAlt}/></span>{appContext.company.telephone}</Typography></a>
                    </Box>
                )
            }

            {
                category === contactUsCategories.general.key &&
                (
                    <Box className={classes.contactBox}>
                        <a href={`mailto:${appContext.company.customerServiceEmail}`}><Typography variant="body1"><span className={classes.imageSpan}><img src={iconEmail} alt={strings.iconEmailAlt}/></span>{appContext.company.customerServiceEmail}</Typography></a>
                        <a href={`tel:${appContext.company.canonicalTelephone}`}><Typography variant="body1"><span className={classes.imageSpan}><img src={iconPhone} alt={strings.iconPhoneAlt}/></span>{appContext.company.telephone}</Typography></a>
                        <MarginBox top={2}>
                            <Typography variant="body1">{strings.phoneOpeningHours}</Typography>
                        </MarginBox>
                    </Box>
                )
            }
        </Box>
    );
};

export default ContactUsSection;
